import React from 'react'
import ProposalPDFView from '../components/proposal/view_pdf'

const AriaV2ViewPDFPage = (props) => {
    return <ProposalPDFView {...props} />
}

export default AriaV2ViewPDFPage
